// 수행평가
import Resource from '../Resource'
import axios from 'axios'
export default class PerformTest extends Resource {
  static ENDPOINT = '/api/test/perform/test'

  constructor (args) {
    super()
    this.extend(args)
  }

  static async list (query) {
    let { data } = await axios.get(this.ENDPOINT, { params: query });
    data = data.reduce((acc, c) => {
      if (!acc[c.code]) acc[c.code] = { }
      acc[c.code] = new PerformTest(c)
      return acc
    }, {})
    return data;
  }

  static create (training, subject, name, code) {
    return new PerformTest({ training, subject, name, code, task1: {}, task2: {}, units: [] })
  }
}
